import React, { useState } from 'react'
import { styled } from 'styled-components'

const MailForm = () => {
    const [email,setEmail] = useState("");

    const handleEmailInputChange = (e) => {
        setEmail(e.target.value)
    }

    const handleMailSubmit = (e) =>{
        e.preventDefault()
    }

  return (
    <Container className='mail-info-container'>
            <h2>Want <i>AMRS</i> updates sent straight to your inbox?</h2>
            {/* Integrate the mailchimp features into the application to send bulk emails to all at once. */}
            <div className="mail-wrapper">
                <div className="mail-style-form-container">
                    <form action="#" onSubmit={handleMailSubmit}>
                        <div className="mailchimp-input-form-container">
                            <input type="email" value={email} onChange={handleEmailInputChange} placeholder='We saved a spot for your email' name='email'id='email'required />
                            <button type='submit' className='mailchimp-form-submit-btn'>SEND</button>
                        </div>
                    </form>
                </div>
                <p>By clicking send you'll receive occasional emails from AMRS. You always have the choice to unsubscribe within every email you receive.</p>
            </div>
    </Container>
  )
}

const Container = styled.section`
    background-color: var(--color-black);
    color: var(--color-white);
    padding: 5em 2em;
    text-align: center;
    h2{
        font-size: 3rem;
        i{
            color: var(--primary-color);
            
        }
    }
    .mail-style-form-container{       
        margin: 3em 0;
        padding: 1em 0;
        border-bottom: 1px solid var(--color-white);
        form{
            input{
                width: 86%;
                background-color: transparent;
                border: none;
                outline: none;
                color: white;
                font-size: 1.5rem;
                &::placeholder{
                    color: var(--color-muted-black);
                    font-size: 1.1rem;
                }
            }
            button{
                background-color: transparent;
                color: var(--color-white);
                border: none;
                font-weight: bold;
                cursor: pointer;
            }
        }
    }
    p{
        color: var(--color-muted-black);
        font-size: 0.9rem;
        line-height: 1;
    }

    /* Media Queries */
    @media only screen and (min-width: 850px){
        text-align: unset;
        padding: 7em 5em;
        h2{
            width: 50%;
            font-size: 4rem;
            transform: translateY(-30%);
        }
        .mail-wrapper{
            width:50%;
            position: relative;
            left: 50%;
        }
    }
    @media only screen and (min-width: 1200px){
        .mail-wrapper{
            width: 40%;
            left: 60%;
        }    
    }
`;

export default MailForm